import { createSlice } from '@reduxjs/toolkit'
import { getProductsACTION, getProductDetailsACTION, getProductRelatedItemsACTION } from '../actions/products.Actions'

const INITIAL_STATE = {
    products: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    productArrange: {
        data: []
    },
    productsDetails: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            error: null
        },
    },
    suggestedItemsState: {
        suggestedItems: [],
        isSuggestedItemsPopupOpen: false,
        isFromSuggestedItemsFlow: false,
        apiMsg: {
            message: null,
            status: null,
            error: null
        }
    }

};

const productsReducer = createSlice({
    name: 'Products',
    initialState: INITIAL_STATE,
    reducers: {
        SET_PRODUCT_SETUP(state, action) {

            var tmpProducts = [];
            if (action.payload.products) {
                tmpProducts = JSON.parse(JSON.stringify(action.payload.products));

            }
            // console.log('SET_PRODUCT_SETUP ', action);
            var allCategoriesData = [];
            //console.log("action.payload.products", action.payload.products)
            if (action.payload.filters && action.payload.filters.length) {
                var searchParam = action.payload.filters.filter(x => x.key === "search").length ? action.payload.filters.filter(x => x.key === "search")[0].value : null;
                var tagParam = action.payload.filters.filter(x => x.key === "tag").length ? action.payload.filters.filter(x => x.key === "tag")[0].value : null;
                if (searchParam) {

                    //console.log("action.payload.products",action.payload.products)
                    action.payload.products.map((category) => {

                        var allCategories = JSON.parse(JSON.stringify(allCategoriesData));

                        if (category.categoryName.toLowerCase().includes(searchParam.toLowerCase())) {
                            allCategories.push(category);
                        }
                        else {
                            var objCategory = {
                                categoryID: category.categoryID,
                                categoryName: category.categoryName,
                                slug: category.slug,
                                products: []
                            }

                            //var productWithoutSubCategory = category.products.filter(x=>!x.subCategoryID);
                            //console.log("productWithoutSubCategory",productWithoutSubCategory);

                            category.products.map((product) => {


                                if (product.name.toLowerCase().includes(searchParam.toLowerCase())) {

                                    if (allCategories && allCategories.length && allCategories.findIndex(x => x.categoryID == product.categoryID) !== -1) {
                                        allCategories[allCategories.findIndex(x => x.categoryID == product.categoryID)].products.push(product);
                                    }
                                    else {
                                        allCategories.push({
                                            categoryID: category.categoryID,
                                            categoryName: category.categoryName,
                                            slug: category.slug,
                                            products: [product]
                                        })
                                    }

                                }



                            })




                        }
                        //console.log("allCategories",allCategories)
                        allCategoriesData = allCategories;

                    })
                }
                else {

                    allCategoriesData = JSON.parse(JSON.stringify(action.payload.products));
                }
                if (tagParam) {
                    var tagCatregories = [];
                    allCategoriesData.map((category) => {
                        category.products.map((product) => {
                            if (product.tags && product.tags.length) {
                                var selectedTagProduct = product.tags.filter(x => x.code === tagParam);
                                if (selectedTagProduct && selectedTagProduct.length) {

                                    if (tagCatregories && tagCatregories.length && tagCatregories.findIndex(x => x.categoryID == product.categoryID) !== -1) {
                                        tagCatregories[tagCatregories.findIndex(x => x.categoryID == product.categoryID)].products.push(product);
                                    }
                                    else {
                                        tagCatregories.push({
                                            categoryID: category.categoryID,
                                            categoryName: category.categoryName,
                                            slug: category.slug,
                                            products: [product]
                                        })
                                    }
                                }

                            }
                        });
                    });

                    //console.log("tagCatregories", tagCatregories)

                    allCategoriesData = tagCatregories;
                    //console.log("allCategories", allCategoriesData)
                    state.productArrange.data = allCategoriesData;

                }

                if (allCategoriesData.length) {
                    //console.log("allCategories", allCategoriesData);
                    //state.productArrange.data = allCategoriesData;

                    tmpProducts = JSON.parse(JSON.stringify(allCategoriesData));

                }
                else{
                    tmpProducts = [];
                }

            }

            var productItemList = [];
            if (tmpProducts.length) {
                tmpProducts.map((category, i) => {
                    var productWithoutSubCategory = category.products.filter(x => !x.subCategoryID);
                    var tempProductWithSubCategory = category.products.filter(x => x.subCategoryID).sort((a, b) => (a.subCategorySortOrder > b.subCategorySortOrder) ? 1 : -1);

                    const groupByCategory = tempProductWithSubCategory.reduce((group, subCategory) => {
                        const { subCategoryID } = subCategory;
                        group[subCategoryID] = group[subCategoryID] ?? [];
                        group[subCategoryID].push(subCategory);
                        return group;
                    }, {});
                    //console.log("groupByCategory", groupByCategory)
                    var productWithSubCategory = [];
                    if (Object.keys(groupByCategory) && Object.keys(groupByCategory).length) {
                        Object.keys(groupByCategory).map((gpItem) => {

                           // console.log("gpItem",groupByCategory[gpItem]);

                            var productWithSubCategoryItems = groupByCategory[gpItem] && groupByCategory[gpItem].length ? groupByCategory[gpItem].sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : -1) : groupByCategory[gpItem];

                            productWithSubCategory.push({
                                subCategoryId: groupByCategory[gpItem][0].subCategoryID,
                                subCategoryName: groupByCategory[gpItem][0].subCategoryName,
                                slug: `${groupByCategory[gpItem][0].categorySlug}-${groupByCategory[gpItem][0].subCategorySlug}`,
                                items: productWithSubCategoryItems 
                              
                            });
                        })
                    }

                    productItemList.push({
                        categoryID: category.categoryID,
                        slug: category.slug,
                        categoryName: category.categoryName,
                        categoryDescription: category.categoryDescription,
                        items: productWithoutSubCategory,
                        subCategories: productWithSubCategory,
                        
                    })

                })

                //console.log("productItemList",productItemList);
            }
            state.productArrange.data = productItemList;


        },
        RESET_PRODUCTSDETAILS(state, action) {
            state.productsDetails = INITIAL_STATE.productsDetails;
        },
        RESET_PRODUCT_STATE(state, action) {
            state.products = INITIAL_STATE.products;
        },
        SET_SUGGESTED_ITEMS(state, action) {
            if (!state.suggestedItemsState) {
                state.suggestedItemsState = { suggestedItems: [], isSuggestedItemsPopupOpen: false, isFromSuggestedItemsFlow: false, apiMsg: { status: null, message: null, error: null } };
            }
            state.suggestedItemsState.suggestedItems = action.payload;
        },
        TOGGLE_SUGGESTED_ITEMS_POPUP(state, action) {
            if (!state.suggestedItemsState) {
                state.suggestedItemsState = { suggestedItems: [], isSuggestedItemsPopupOpen: false, isFromSuggestedItemsFlow: false, apiMsg: { status: null, message: null, error: null } };
            }
            state.suggestedItemsState.isSuggestedItemsPopupOpen = action.payload;
        },
        SET_SUGGESTED_ITEMS_SOURCE_FLAG(state, action) {
            if (!state.suggestedItemsState) {
                state.suggestedItemsState = { suggestedItems: [], isSuggestedItemsPopupOpen: false, isFromSuggestedItemsFlow: false, apiMsg: { status: null, message: null, error: null } };
            }
            state.suggestedItemsState.isFromSuggestedItemsFlow = action.payload;
        }
    },
    extraReducers: (builder) => {
        //------------------------------- getProductsACTION start -------------------------
        // eslint-disable-next-line
        builder.addCase(getProductsACTION.fulfilled, (state, action) => {
            //console.log("getProductsACTION", action);
            state.products.data = action.payload.data
            state.products.apiMsg.status = action.meta.requestStatus;
            state.products.apiMsg.message = action.payload.message.message;
        }),
            builder.addCase(getProductsACTION.pending, (state, action) => {
                //console.log("getProductsACTION pending", action);
                state.products.apiMsg.status = action.meta.requestStatus;
            }),
            builder.addCase(getProductsACTION.rejected, (state, action) => {
                // console.log("getProductsACTION rejected", action);
                state.products.apiMsg.message = action.error.message;
                state.products.apiMsg.status = action.meta.requestStatus;
            }),
            //------------------------------- getProductsACTION end -------------------------
            //------------------------------- getProductDetailsACTION start -------------------------

            builder.addCase(getProductDetailsACTION.fulfilled, (state, action) => {
                //console.log("getProductDetailsACTION", action);
                state.productsDetails.data = action.payload.data
                state.productsDetails.apiMsg.status = action.meta.requestStatus;
                state.productsDetails.apiMsg.message = action.payload.message.message;
            }),
            builder.addCase(getProductDetailsACTION.pending, (state, action) => {
                //console.log("getProductDetailsACTION pending", action);
                state.productsDetails.apiMsg.status = action.meta.requestStatus;
            }),
            builder.addCase(getProductDetailsACTION.rejected, (state, action) => {
                // console.log("getProductDetailsACTION rejected", action);
                state.productsDetails.apiMsg.message = action.error.message;
                state.productsDetails.apiMsg.status = action.meta.requestStatus;
            }),
        //------------------------------- getProductDetailsACTION end -------------------------

        //------------------------------- getProductRelatedItemsACTION start -------------------------

            builder.addCase(getProductRelatedItemsACTION.fulfilled, (state, action) => {
                state.suggestedItemsState.suggestedItems = action.payload.data || [];
                state.suggestedItemsState.apiMsg.status = action.meta.requestStatus;
                state.suggestedItemsState.apiMsg.message = action.payload.message?.message;
            }),
            builder.addCase(getProductRelatedItemsACTION.pending, (state, action) => {
                state.suggestedItemsState.apiMsg.status = action.meta.requestStatus;
            }),
            builder.addCase(getProductRelatedItemsACTION.rejected, (state, action) => {
                state.suggestedItemsState.apiMsg.message = action.error.message;
                state.suggestedItemsState.apiMsg.status = action.meta.requestStatus;
            })
        //------------------------------- getProductRelatedItemsACTION end -------------------------
    }
})

export const { SET_PRODUCT_SETUP, RESET_PRODUCTSDETAILS, RESET_PRODUCT_STATE, SET_SUGGESTED_ITEMS, TOGGLE_SUGGESTED_ITEMS_POPUP, SET_SUGGESTED_ITEMS_SOURCE_FLAG } = productsReducer.actions;
export default productsReducer.reducer;